import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import sessionCoordinator from 'utils/auth/sessionCoordinator';

interface Props {
  actionLabel?: string;
  message?: string;
  title?: string;
}

const AuthenticationErrorScreen: React.FC<Props> = ({
  actionLabel = 'Try Again',
  message,
  title = 'Sign-in could not be completed',
}) => {
  return (
    <Stack spacing={2} alignItems="flex-start" sx={{ p: 4 }}>
      <Typography variant="h5">{title}</Typography>
      {message && <Typography>{message}</Typography>}
      <Button variant="contained" onClick={() => void sessionCoordinator.retryAuthentication()}>
        {actionLabel}
      </Button>
    </Stack>
  );
};

export default AuthenticationErrorScreen;
